import React from 'react';
import image1 from './image1.jpg';
import image2 from './image2.jpg';
import image3 from './image3.jpg';
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';
import css from './BecomeCreatorSection.module.css';
import { Css } from '@mui/icons-material';

const BecomeCreatorSection = () => {
  const cardsData = [
    {
      title: '3d Environmental Artist | Scan Adventurer | Blender Wizard | XGrids Expert',
      image: image1,
      tag: '@PointCloudJ',
      description:
        '“I like scans that feel lived in. A crack in a bench, a sticker on a pole—the imperfections make it real.”',
    },
    {
      title: 'Heritage Preserver | Drone Mapper | Photogrammetry Nerd',
      image: image2,
      tag: '@GeoGlider',
      description:
        '“Scanwow gives me a way to share these places before they disappear. Every dataset is a piece of history.”',
    },
    {
      title: 'XR Developer | Tactile Technologist | Scanwow Superuser',
      image: image3,
      tag: '@StreetSnapper1',
      description:
        '“Scan data is more than geometry. It’s a gateway to interaction, learning, and wonder.”',
    },
  ];

  return (
    <div className={css.wrapper}>
      <div className={css.title}>
        <p>Built by brilliant minds.</p>
        <p>Meet some of the makers behind the 3d assets.</p>
      </div>
      <div className={css.cardsWrapper}>
        {cardsData.map((card, index) => (
          <a href="/become-a-creator" key={index} className={css.card}>
            <p className={css.smallText}>
              <b>Top</b> rated creator
            </p>
            <div className={css.starIconWrapper}>
              <StarRateRoundedIcon className={css.starIcon} />
            </div>

            <p className={css.cardTitle}>{card.title}</p>

            <div className={css.separator}></div>

            <img src={card.image} alt={card.title} className={css.cardImage} />

            <div className={css.tagsWrapper}>
              <p className={css.tag}>{card.tag}</p>
              <p className={css.tag}>{card.tag}</p>
            </div>

            <p className={css.cardDescription}>{card.description}</p>

            <div className={css.exporeButton}>Explore Their Work</div>
          </a>
        ))}
      </div>

      <a href="/become-a-creator" className={css.becomeCreatorButton}>
        <span>Become A Creator</span>
      </a>
    </div>
  );
};

export default BecomeCreatorSection;
